import * as styles from "./SectionThreeColCardsDoubleFeature.module.scss";

import React, { useState } from "react";

import ArticleOrEventCard from "../../../components/SignPostCards/ArticleOrEventCard";
import StandardSignPostCard from "../../../components/SignPostCards/StandardSignPostCard";
import { Chevron } from "../../../components/common/Icons";
import WrappedSection from "../../WrappedSection/WrappedSection";

import cx from "classnames";

export interface SectionThreeColCardsDoubleFeatureProps {
	title?: string;
	items: DogsTrust.SignPostCardProps[];
	limit?: number;
	isHomePage: boolean;
	jumpLinksTitle?: string;
}

export const SectionThreeColCardsDoubleFeature: React.FC<
	SectionThreeColCardsDoubleFeatureProps
> = ({ title, items, isHomePage, jumpLinksTitle }) => {
	items.sort((a, b) =>
		a.priority < b.priority ? -1 : a.priority < b.priority ? 1 : 0,
	);

	const [showAll, setShowAll] = useState("show");
	const canShowAll = showAll !== "show";
	return (
		<WrappedSection
			sectionName="SectionThreeColCardsDoubleFeature"
			isHomePage={isHomePage}
		>
			{title && (
				<div className={styles.titlewrapper}>
					{jumpLinksTitle ? (
						<h2 className={styles.title} data-jumplinkstitle={jumpLinksTitle}>
							{title}
						</h2>
					) : (
						<h2 className={styles.title}>{title}</h2>
					)}
				</div>
			)}

			<div className={styles.columns}>
				<div className={styles.signpostcardsection}>
					{items.slice(0, 2).map((item) => (
						<StandardSignPostCard
							{...item}
							key={item.title}
							label={item.label}
							isSuccessStory
							buttonVariant="secondary"
							forceSquare
						/>
					))}
				</div>
				<div className={styles.articlecardsection}>
					<div
						className={cx({
							[styles.cards]: canShowAll,
							[styles.collapsedcards]: !canShowAll,
						})}
					>
						{items.slice(2).map((card) => (
							<ArticleOrEventCard key={card.title} {...card} noOrphan />
						))}
					</div>
					<div className={styles.showmorearea}>
						{!canShowAll && <div className={styles.gradient} />}
						<button
							type="button"
							className={canShowAll ? styles.showless : styles.showmore}
							onClick={() =>
								setShowAll((prev) =>
									prev === "initial"
										? "show"
										: prev === "show"
											? "hide"
											: "show",
								)
							}
						>
							<div className={styles.text}>
								{`Show ${canShowAll ? "less" : "more"}`}{" "}
								<Chevron
									className={styles.chevron}
									height={"16px"}
									width={"16px"}
									rotation={canShowAll ? 0 : 180}
								/>
							</div>
						</button>
						{showAll !== "initial" && (
							<span className={styles.accessibilityalert} role="alert">
								{showAll === "show"
									? "All items are now visible"
									: "Some items are now hidden"}
							</span>
						)}
					</div>
				</div>
			</div>
		</WrappedSection>
	);
};

export default SectionThreeColCardsDoubleFeature;
